module.exports = __webpack_public_path__ + "media/images/mailer-new-survey-reference-52b6e1719d8d7c19e2f54773bffd5967.png";